export const QuestionType_Text = "Text";
export const QuestionType_TextArea = "TextArea";
export const QuestionType_Checkbox = "CheckBox";
export const QuestionType_RadioButtonList = "RadioButtonList";
export const QuestionType_ComboBox = "ComboBox";
export const QuestionType_CheckBoxList = "CheckBoxList";
export const QuestionType_CountryComboBox = "CountryComboBox";
export const QuestionType_RadioButton = "RadioButton";
